import React, { useEffect, useState } from "react";
import { useLocation, useParams ,useNavigate } from "react-router-dom";
import { Card, Button, Tag, Modal } from "antd";
import dayjs from "dayjs";
import logo from "./logo.png";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

function MockInterviewDetails() {
  const { id } = useParams();

  const [interviewData, setInterviewData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchInterview();
  }, [id]); // ✅ FIX

  const fetchInterview = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/mock-interview/get-single-interview`,
        { id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.success) {
        setInterviewData(res.data.data);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

useEffect(() => {
  if (!loading && interviewData) {
    const isCompleted =
      interviewData.InterviewStatus === "COMPLETED";

    if (isCompleted) {
      navigate(`/academy/mentee-dashboard/mock-interview/${id}/completed-mock-interview`, { replace: true });
    } else {
      navigate(`/academy/mentee-dashboard/mock-interview/${id}/upcoming-mock-interview`, { replace: true });
    }
  }
}, [loading, interviewData, id, navigate]);

  return (
    <div className="min-h-screen p-10 bg-slate-50" />
  );
}





export default MockInterviewDetails;